import { render, staticRenderFns } from "./addVersionModel.vue?vue&type=template&id=30c10b37"
import script from "./addVersionModel.vue?vue&type=script&lang=js"
export * from "./addVersionModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30c10b37')) {
      api.createRecord('30c10b37', component.options)
    } else {
      api.reload('30c10b37', component.options)
    }
    module.hot.accept("./addVersionModel.vue?vue&type=template&id=30c10b37", function () {
      api.rerender('30c10b37', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/applicationVersionManage/addVersionModel.vue"
export default component.exports